import { MenuItem, Text } from "@chakra-ui/react"
import PropTypes from "prop-types"
import { useBrandedTranslation } from "../../../../../../common/hooks/useBrandedTranslation"
import { scrollToSection } from "../../../../../../common/utils/pdp-utils"
import { CRelation } from "../../../../../shared/Icons"
import { useAccessoriesFilter } from "../../../context/AccessoriesFilterContext"

/* closeMenu is optional passed from mobile layers to first close the layer then scroll to the Accessories section */
const AccessoriesMenuItem = ({ articleCode, accessories, closeMenu }) => {
  const { t } = useBrandedTranslation()
  const setAccessoriesFilter = useAccessoriesFilter()

  const handleClick = () => {
    /* Apply the selected article from the article table to the accessories filter menu
      and scroll to the "Accessories" section */
    setAccessoriesFilter(articleCode)

    if (closeMenu) {
      closeMenu()
      setTimeout(() => scrollToSection(document.getElementById("accessories")), 100)
    } else {
      scrollToSection(document.getElementById("accessories"))
    }
  }

  /* If the article doesn't have accessories, don't render the accessories button */
  if (!accessories) return null

  return (
    <MenuItem icon={<CRelation />} onClick={handleClick} aria-label="Go to article accessories" closeOnSelect>
      <Text fontWeight="medium">{t("pdp-article-more-accessories")}</Text>
    </MenuItem>
  )
}

export default AccessoriesMenuItem

AccessoriesMenuItem.propTypes = {
  articleCode: PropTypes.string,
  accessories: PropTypes.array,
  closeMenu: PropTypes.func,
}
